/**
 * Dokuma Live Chat Widget - Entry Point
 * 
 * Usage:
 *   <script src="https://your-domain.com/widget/dokuma-chat.min.js" 
 *           data-api-url="https://your-domain.com" async defer></script>
 * 
 * Or manual initialization:
 *   const chat = new DokumaChat({ apiUrl: 'https://your-domain.com' });
 *   chat.init();
 */

import { DokumaChat } from './widget';
import type { WidgetConfig } from './types';

// Auto-initialize if script tag has data-api-url attribute
(() => {
  // Find the current script tag
  const scripts = document.getElementsByTagName('script');
  const currentScript = scripts[scripts.length - 1];
  
  if (currentScript) {
    const apiUrl = currentScript.getAttribute('data-api-url');
    const position = currentScript.getAttribute('data-position') as 'left' | 'right' | null;
    const primaryColor = currentScript.getAttribute('data-primary-color');

    if (apiUrl) {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          const chat = new DokumaChat({
            apiUrl,
            websiteUrl: window.location.href,
            position: position || 'right',
            primaryColor: primaryColor || undefined,
          });
          chat.init();
        });
      } else {
        const chat = new DokumaChat({
          apiUrl,
          websiteUrl: window.location.href,
          position: position || 'right',
          primaryColor: primaryColor || undefined,
        });
        chat.init();
      }
    }
  }
})();

// Expose to window for manual initialization
declare global {
  interface Window {
    DokumaChat: typeof DokumaChat;
  }
}

if (typeof window !== 'undefined') {
  window.DokumaChat = DokumaChat;
}

// Export for module usage
export { DokumaChat };
export type { WidgetConfig };
